import React from 'react';
import { acceptsFunctionalCookies } from '@noths/polaris-client-gdpr-compliance';
import { GetServerSideProps } from 'next';

import { RibbonsPage } from 'src/components/templates/RibbonsPage';
import { getPageContent } from 'src/content/getPageContent';
import { ContentPageProps, PageConfiguration, PageMetadata } from 'src/types/PageProps';
import { getPageMetadata } from 'src/utils/getPageMetadata';
import { getRecommendationsSessionId } from 'src/utils/getRecommendationsSessionId';
import { RecommendationsContextProvider } from '../components/contexts/RecommendationsContext';
import { SKIP_CONTENT_TARGET_ID } from '../constants/elementIds';

const pageConfig: PageConfiguration = {
  env: process.env.NODE_ENV,
  contentType: 'homepage',
  pageType: 'homepage',
  trackingCategory: 'Home',
  hasSeoLinkedData: true,
};

export const getServerSideProps: GetServerSideProps<ContentPageProps> = async (context) => {
  const pageMetadata: PageMetadata = {
    ...getPageMetadata(context),
    functionalCookiesConsented: acceptsFunctionalCookies(context.req.cookies),
    recommendationsSessionId: getRecommendationsSessionId(context),
  };

  try {
    const pageContent = await getPageContent(pageConfig, pageMetadata);

    return {
      props: {
        pageConfig,
        pageMetadata,
        pageContent: pageContent.pageContent,
        category: pageConfig.trackingCategory, // is used for tracking the page
        navData: pageContent.navData,
        topBannerData: pageContent.topBannerData,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};

const Homepage = (props: ContentPageProps) => {
  return (
    <div id={SKIP_CONTENT_TARGET_ID}>
      <RecommendationsContextProvider {...props}>
        <RibbonsPage {...props} />;
      </RecommendationsContextProvider>
    </div>
  );
};

export default Homepage;
